import { TimeRangeOption } from '../../../ui/gzDatetimeFilter/types';

export interface DateFilterProps {
  label: string;
  labelWidth: string;
  placeholder: string;
  timezone: string;
  timeRangeOptions: TimeRangeOption[];
  userLocale: string;
  min?: number;
  max?: number;
}

export interface SearchQueryProps {
  queryInputPlaceholder: string;
  queryBtnString: string;
  clearBtnString: string;
  errorMessages: object;
  hintTextString: string;
  helperHref: string;
  manualResize?: boolean;
  enterKeyEnabled?: boolean;
}

export enum SearchQueryPanelEvents {
  UPDATE_COMPLETE = 'updateComplete',
  SAVE = 'save',
  SAVE_AS = 'saveAs',
  DISCARD = 'discard',
  EXPORT_CSV = 'exportCsv',
  RESET_FILTERS = 'resetFilters',
}

export interface ActionBtnProps {
  saveBtnString: string;
  saveAsBtnString: string;
  discardBtnString: string;
}
